const defaultState = {
    data: {},
    loading: false,
    error: null,
    timestamp: 0,
};

const main = (state = defaultState, action) => {
    switch (action.type) {
        case "CONFIG_INFORMATION_SUCCESS":
            return {
                ...state,
                error: null,
                data: action.payload,
                timestamp: action.payload.timestamp,
            };
        case "CONFIG_INFORMATION_LOADING":
            return {
                ...state,
                loading: action.loading,
            };
        case "CONFIG_INFORMATION_ERROR":
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        case "CONFIG_INFORMATION_EXPIRE":
            return {
                ...state,
                timestamp: 0,
            };

        case "CONFIG_INFORMATION_RESET":
            return defaultState;

        case "CONFIG_SESSION_RESET":
            return defaultState;

        default:
            return state;
    }
};

export default main;
